// extracted by mini-css-extract-plugin
export default {"btn":"EditCat_btn__GOvUe"};